import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ListadoSeguimientoHabilitacion() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS_TELAS = `${process.env.REACT_APP_URL_INVENTARIOS_TELAS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");


  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");


  const [modalDesgloce, setModalDesgloce] = useState(false);
  const toggleDesgloce = () => setModalDesgloce(!modalDesgloce);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
    const [value, setValue] = useState("");
    const [selectedHabilitacion, setSelectedHabilitacion] = useState("");

  const ITEMS_PER_PAGE = 50;

  const [movimientos, setMovimientos] = useState([]);

  useEffect(() => {
    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function BuscaArticulo(selectedHabilitacion) {
    setSelectedArticulo(selectedHabilitacion._id);

    // Jala Movimientos
    axios
      .get(`${URL_SEGUIMIENTOS}Habilitacion/${selectedHabilitacion._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMovs = response.data;
        setComments(allMovs);
        setMovimientos(allMovs);
      })
      .catch((err) => {
        console.log(err);
      });
  }


  // function PDFTabla() {
  //   let total_inventarioTelas = 0;
  //   let total_pedido = 0;
  //   let total_disponible = 0;

  //   const data = comments
  //     .filter(
  //       (comment) =>
  //         comment.destino.toLowerCase().includes(search.toLowerCase()) ||
  //         comment.tipoMov.toLowerCase().includes(search.toLowerCase())
  //     )
  //     .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
  //     .map((a) => {
  //       if (
  //         (selectedArticulo == 0 || selectedArticulo == a.idArticulo)
  //       ) {
  //         total_inventarioTelas = total_inventarioTelas + a.inventarioTelas;
  //         total_pedido = total_pedido + a.pedido;
  //         total_disponible = total_disponible + a.disponible;
  //         return [
  //           a.codigo,
  //           a.nombre,
  //           a.composicion,
  //           a.unidad,
  //           a.tiposTelas,
  //           new Intl.NumberFormat("en-US").format(a.inventarioTelas),
  //           new Intl.NumberFormat("en-US").format(a.pedido),
  //           new Intl.NumberFormat("en-US").format(a.disponible),
  //         ];
  //       }
  //     });
  //   const dataPDF = Object.values(data);
  //   const dataPDFLimpia = dataPDF.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 120, 15, 60, 25);
  //   doc.text(`Listado Disponible`, 20, 40);
  //   doc.autoTable({
  //     head: [
  //       [
  //         "Codigo",
  //         "Nombre",
  //         "Composicion",
  //         "Unidad",
  //         "Tipo de Tela",
  //         "InventarioTelas",
  //         "Pedido",
  //         "Disponible",
  //       ],
  //     ],
  //     body: dataPDFLimpia,
  //     startY: 45,
  //     foot: [
  //       [
  //         "",
  //         "",
  //         "",
  //         "",
  //         "Total",
  //         new Intl.NumberFormat("en-US").format(total_inventarioTelas),
  //         new Intl.NumberFormat("en-US").format(total_pedido),
  //         new Intl.NumberFormat("en-US").format(total_disponible),
  //       ],
  //     ],
  //     showFoot: "lastPage",
  //   });
  //   /////
  //   const data2 = commentsData.map((a) => {
  //     // total_importe = total_importe + totalDesc
  //     return [
  //       a.fecha,
  //       a.tipoMov,
  //       a.numMov,
  //       a.destino,
  //       new Intl.NumberFormat("en-US").format(a.cantidad),
  //     ];
  //   });
  //   const dataPDF2 = Object.values(data2);
  //   const dataPDFLimpia2 = dataPDF2.filter(function (el) {
  //     return el != null;
  //   });
  //   doc.autoTable({
  //     head: [
  //       ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Cantidad"],
  //     ],
  //     body: dataPDFLimpia2,
  //     foot: [["", "", "", "", "", ""]],
  //     showFoot: "lastPage",
  //   });

  //   //////
  //   doc.save(`Seguimiento.pdf`);
  // }

  // function excel() {
  //   const dataExcel = commentsData
  //     .filter(
  //       (comment) =>
  //         comment.destino.toLowerCase().includes(search.toLowerCase()) ||
  //         comment.tipoMov.toLowerCase().includes(search.toLowerCase())
  //     )
  //     .map((a) => {
  //       if (
  //         (selectedArticulo == 0 || selectedArticulo == a.idArticulo)
  //       ) {
  //         return {
  //           Fecha: a.fecha,
  //           Movimiento: a.tipoMov,
  //           Numero: a.numMov,
  //           Destino: a.destino,
  //           Cantidad: a.cantidad,
  //         };
  //       }
  //     });
  //   const dataExportExcel = Object.values(dataExcel);
  //   const dataExcelLimpia = dataExportExcel.filter(function (el) {
  //     return el != null;
  //   });

  //   var option = {};

  //   option.fileName = "ListadoSeguimientoHabilitacion";

  //   option.datas = [
  //     {
  //       sheetData: dataExcelLimpia,
  //       sheetName: "ListadoSeguimientoHabilitacion",
  //       sheetFilter: [
  //         "Fecha",
  //         "Movimiento",
  //         "Numero",
  //         "Destino",
  //         "Cantidad",
  //       ],
  //       sheetHeader: [
  //         "Fecha",
  //         "Movimiento",
  //         "Numero",
  //         "Destino",
  //         "Cantidad",
  //       ],
  //     },
  //   ];

  //   var toExcel = new ExportJsonExcel(option);
  //   toExcel.saveExcel();
  // }

  // function enviaMail() {

  //   const data2 = commentsData.map((a) => {
  //     // total_importe = total_importe + totalDesc
  //     return [
  //       a.fecha,
  //       a.tipoMov,
  //       a.numMov,
  //       a.destino,
  //       a.color,
  //       new Intl.NumberFormat("en-US").format(a.cantidad),
  //     ];
  //   });
  //   const dataPDF2 = Object.values(data2);
  //   const dataPDFLimpia2 = dataPDF2.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 120, 15, 60, 25);
  //   doc.text(`Listado Disponible`, 20, 40);


  //   doc.autoTable({
  //     head: [
  //       ["Fecha", "Movimiento", "Numero", "Cliente/Prov",  "Cantidad"],
  //     ],
  //     body: dataPDFLimpia2,
  //     foot: [["", "", "", "", "", ""]],
  //     showFoot: "lastPage",
  //   });

  //   //////

  //   var att = doc.output("arraybuffer");
  //   var base64File = encode.encode(att, "base64");

  //   // Envia el Mail
  //   axios
  //     .post(
  //       URL_SEND_MAIL_ATT,
  //       {
  //         subject: "Listado Seguimiento",
  //         email: mailTo,
  //         fileName: "ListadoSeguimientoHabilitacion.pdf",
  //         att: base64File,
  //         text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
  //        <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
  //        <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
  //        <tbody>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
  //        </tbody>
  //        <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
  //        <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
  //        </table>`,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       toggleMail();
  //       Swal.fire("Good job!", "Enviado con exito", "success");
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data}`,
  //       });
  //       console.log(error);
  //     });
  // }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Movimiento", field: "tipoMov", sortable: false },
    { name: "Numero", field: "numMov", sortable: false },
    { name: "Articulo", field: "modelo", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: false },
    { name: "Cliente / Proveedor", field: "destino", sortable: false },
    { name: "Cantidad", field: "cantidad", sortable: false },
    { name: "Inventario", field: "acumulado", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.destino.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.tipoMov.toLowerCase().includes(search.toLowerCase()) ||
          comment.modelo.toLowerCase().includes(search.toLowerCase()) ||
           comment.numMov.toString().includes(search) ||
          comment.cantidad.toString().includes(search) ||
          comment.acumulado.toString().includes(search) 
      );
    }

    setTotalItems(computedComments.length);

  //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "acumulado" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "cantidad" ||
        sorting.field == "acumulado" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "cantidad" ||
        sorting.field == "acumulado" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

   const options = articulos.map((option) => {
  const junta = option.nombre + " " + option.descripcion
  const firstLetter = option.nombre[0].toUpperCase();
  return {
    firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
    ...option,
    junta,
  };
});

  let totalDisponible = 0;
  let totalPedido = 0;
  let totalInventarioTelas = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            {/* <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  // onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  // onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  // onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col> */}
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                size="sm"
                color="success"
                // onClick={enviaMail}
              >
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Seguimiento Habilitacion</h3>
          <div className="row">
            <div className="col-md-2">
              <Label>Habilitacion</Label>
              <Autocomplete
                size="small"
                value={selectedHabilitacion}
                onChange={(event, selectedHabilitacion) => {
                  if (selectedHabilitacion) {
                    setValue(selectedHabilitacion); // si lo necesitas
                    setSelectedHabilitacion(selectedHabilitacion); // si usas un estado
                    BuscaArticulo(selectedHabilitacion); // llama la función con el id y el objeto seleccionado
                  }
                }}
                options={options.sort(
                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                )}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.junta}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona"
                    variant="outlined"
                  />
                )}
                renderOption={(option) => (
                  <React.Fragment>
                    {option.nombre} {option.descripcion}
                  </React.Fragment>
                )}
              />
            </div>

            <div className="col-md-10 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <br />

          {/* Tabla Movimientos */}
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />

            <tbody>
              {commentsData
                // .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
                .map((a) => {
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.tipoMov}</td>
                      <td>{a.numMov}</td>
                      <td>{a.modelo}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.destino}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.acumulado)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoSeguimientoHabilitacion;
